import React, { useState } from 'react';
import { Heading, Text, Button, Flex } from '@vibe/core';

interface Props {
  saving: boolean;
  onSave: (name: string) => void;
  onClose: () => void;
}

const BookmarkDialog: React.FC<Props> = ({ saving, onSave, onClose }) => {
  const [name, setName] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (trimmed) {
      onSave(trimmed);
    }
  };

  return (
    <div className="rp-bookmark-overlay" onClick={onClose}>
      <div
        className="rp-bookmark-dialog"
        onClick={(e) => e.stopPropagation()}
      >
        <form onSubmit={handleSubmit}>
          <Heading type={Heading.types.H3} style={{ marginBottom: 12 }}>
            Bookmark Report
          </Heading>
          <Text
            type={Text.types.TEXT2}
            style={{ color: '#676879', marginBottom: 16 }}
          >
            Save this report configuration for quick access later.
          </Text>
          <div className="rp-report-config__field">
            <Text type={Text.types.TEXT2} weight={Text.weights.BOLD}>
              Bookmark Name
            </Text>
            <input
              className="rp-report-config__input"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Q1 Team Utilization"
              maxLength={200}
              autoFocus
            />
          </div>
          <Flex
            gap={Flex.gaps.SMALL}
            justify={Flex.justify.END}
            style={{ marginTop: 16 }}
          >
            <Button
              type="submit"
              kind={Button.kinds.PRIMARY}
              size={Button.sizes.SMALL}
              disabled={!name.trim() || saving}
            >
              {saving ? 'Saving...' : 'Save'}
            </Button>
            <Button
              kind={Button.kinds.TERTIARY}
              size={Button.sizes.SMALL}
              onClick={onClose}
            >
              Cancel
            </Button>
          </Flex>
        </form>
      </div>
    </div>
  );
};

export default BookmarkDialog;
